import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TasksService} from '../../../../../data/tasks/tasks.service';
import {ShortTask} from '../../../../../data/tasks/short-task';
import {MiscSnackBarService} from '../../../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';

@Component({
  selector: 'app-short-tasks-list-dialog',
  templateUrl: './short-tasks-list-dialog.component.html',
  styleUrls: ['./short-tasks-list-dialog.component.scss']
})
export class ShortTasksListDialogComponent implements OnInit {
  shortTasks: ShortTask[];

  loadingSpinner = false;

  constructor(
    private snackBarService: MiscSnackBarService,
    protected dialogRef: MatDialogRef<ShortTasksListDialogComponent>,
    protected tasksService: TasksService,
    @Inject(MAT_DIALOG_DATA) private data: {
      projectId: number,
      checkItemsIds: number[]
    }
  ) {
  }

  ngOnInit(): void {
    this.getUnresolvedTasks()
  }

  getUnresolvedTasks() {
    this.tasksService.getUnresolvedTasksForProject(this.data.projectId).subscribe(list => {
      this.shortTasks = list;
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

  addToOrder(task: ShortTask) {
    this.loadingSpinner = true;

    this.tasksService.addToOrder(task.id, this.data.checkItemsIds).subscribe(newTask => {
      this.dialogRef.close(newTask)
    }, error => {
      this.loadingSpinner = false;
      this.snackBarService.openErrorSnackBar(error.message)
    })
  }
}
